import React, { FC } from 'react';
import { Heading } from '../../shared/Heading';
import { InnerHTML } from '../../shared/InnerHTML';
import { Link, RouterLink } from '../../shared/Link';
import { ButtonSize } from '../../shared/Button';
import { MediaBreakpoint, useBreakpointInfo } from '../../../hooks/useDeviceInfo';
import { checkIsUrlExternal, handleLinkSlashSymbol } from '../../../utils/links-helper/links-helper';
import { joinStrings } from '../../../utils/string';

export type ItvCarouselSlide = {
  id?: string | number;
  imgSrc: string;
  mobileImgSrc?: string;
  imgAlt?: string;
  title: string;
  subTitle?: string;
  buttonLabel?: string;
  buttonLink?: string;
  openInNewTab?: boolean;
  termsAndConditions?: string;
  className?: string;
};

export const ItvCarouselSlideComponent: FC<ItvCarouselSlide> = ({
  imgSrc,
  mobileImgSrc,
  imgAlt,
  title,
  subTitle,
  buttonLabel,
  buttonLink,
  openInNewTab,
  termsAndConditions,
  className,
}) => {
  const isMobile = useBreakpointInfo([MediaBreakpoint.MOBILE]);
  const buttonSize: ButtonSize = isMobile ? 'medium' : 'large';

  const backgroundImage = isMobile ? mobileImgSrc || imgSrc : imgSrc;

  const hasButton = Boolean(buttonLabel && buttonLink);
  const hasTerms = Boolean(termsAndConditions);

  const isExternalUrl = buttonLink && checkIsUrlExternal(buttonLink);
  const launchURL = buttonLink ? handleLinkSlashSymbol(buttonLink) : '';

  return (
    <div
      className={joinStrings(['itv-carousel-slide', className])}
      role="banner"
      aria-label={imgAlt || title}
      style={{ backgroundImage: `url("${backgroundImage}")` }}
    >
      <div className="itv-carousel-slide__overlay">
        <div className="itv-carousel-slide__body">
          <div className="itv-carousel-slide__title">
            <Heading level={2}>{title}</Heading>
          </div>

          {subTitle && (
            <div className="itv-carousel-slide__subtitle">
              <InnerHTML text={subTitle} />
            </div>
          )}

          {hasButton && (
            <div className="itv-carousel-slide__cta">
              {isExternalUrl ? (
                <Link
                  buttonStyle={{ variant: 'primary', size: buttonSize }}
                  href={launchURL}
                  target={openInNewTab ? '_blank' : '_self'}
                >
                  <span>{buttonLabel}</span>
                </Link>
              ) : (
                <RouterLink buttonStyle={{ variant: 'primary', size: buttonSize }} to={launchURL}>
                  <span>{buttonLabel}</span>
                </RouterLink>
              )}
            </div>
          )}
        </div>

        {hasTerms && (
          <div className="itv-carousel-slide__terms">
            <InnerHTML text={termsAndConditions || ''} />
          </div>
        )}
      </div>
    </div>
  );
};
